import { Link } from "react-router-dom";
import WhatsAppButton from "./ui/whatsapp-button";
import CompanyDeckButtonFooter from "./ui/company-deck-button-footer";
import PyCrayForgeYoutubeButton from "./ui/pycray-forge-youtube-button";
import { scrollToSection } from "../utils/scrollToSection";
import {
  COMPANY_DECK_LABEL,
  COMPANY_DECK_URL,
  COMPANY_DECK_FILENAME,
} from "../constants/company-deck";

const footerLinks = [
  { name: "Home", href: "/" },
  { name: "AI Use Cases", href: "/use-cases" },
  { name: "Forge", href: "/forge" },
  { name: "Sessions", href: "/sessions" },
  { name: "ReviewLoop", href: "https://www.reviewloop.in/", external: true },
  { name: "About Us", href: "/about-us" },
  { name: "Careers", href: "/careers" },
];

export default function Footer() {
  const handleSectionClick = (sectionId) => {
    if (window.location.pathname === "/") {
      scrollToSection(sectionId);
    } else {
      window.location.href = `/#${sectionId}`;
    }
  };

  return (
    <footer className="bg-slate-900 text-white overflow-hidden">
      <div className="page-container py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-10 mb-10 sm:mb-12">
          <div>
            <p className="font-bold text-lg mb-2">PyCray Technologies</p>
            <p className="text-white/60 text-sm mb-1">IIT · IIM Alumni-Founded</p>
            <p className="text-white/60 text-sm mb-4">Pune, Maharashtra, India</p>
            <a
              href="mailto:info@pycray.com"
              className="text-white/70 hover:text-white text-sm block mb-1 transition-colors"
            >
              info@pycray.com
            </a>
            <a
              href="https://www.pycray.com"
              className="text-white/70 hover:text-white text-sm transition-colors"
            >
              www.pycray.com
            </a>
          </div>

          <nav>
            <p className="font-medium mb-4 text-sm uppercase tracking-wider text-white/40">
              Links
            </p>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-2">
              {footerLinks.map((item) => (
                <li key={item.name}>
                  {item.sectionId ? (
                    <button
                      type="button"
                      onClick={() => handleSectionClick(item.sectionId)}
                      className="text-white/70 hover:text-white text-sm transition-colors"
                    >
                      {item.name}
                    </button>
                  ) : item.external ? (
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white/70 hover:text-white text-sm transition-colors"
                    >
                      {item.name}
                    </a>
                  ) : (
                    <Link
                      to={item.href}
                      className="text-white/70 hover:text-white text-sm transition-colors"
                    >
                      {item.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <p className="font-medium mb-4 text-sm uppercase tracking-wider text-white/40">
              Get in touch
            </p>
            <div className="flex flex-col gap-3 max-w-xs">
              <CompanyDeckButtonFooter className="w-full" />
              <WhatsAppButton label="Chat with us" className="w-full" />
              <PyCrayForgeYoutubeButton footer className="w-full" />
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 sm:pt-8 text-center text-[11px] sm:text-xs text-white/50 space-y-3">
          <p className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-y-2 gap-x-2">
            <span>Copyright © 2026 PyCray Technologies</span>
            <span className="hidden sm:inline">·</span>
            <span className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
              <Link to="/terms-and-conditions" className="hover:text-white whitespace-nowrap">
                Terms & Conditions
              </Link>
              <span>·</span>
              <Link to="/privacy-policy" className="hover:text-white whitespace-nowrap">
                Privacy Policy
              </Link>
              <span>·</span>
              <a
                href={COMPANY_DECK_URL}
                download={COMPANY_DECK_FILENAME}
                className="hover:text-white whitespace-nowrap"
              >
                {COMPANY_DECK_LABEL}
              </a>
            </span>
          </p>
          <p className="leading-relaxed break-words px-2">
            <span className="block sm:inline">CIN: U62013UP2023PTC180322</span>
            <span className="hidden sm:inline"> · </span>
            <span className="block sm:inline">GST: 09AANCP6815A1ZD</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
